import { render } from "./GuideCTA.vue?vue&type=template&id=0a53475e"
import script from "./GuideCTA.vue?vue&type=script&lang=js"
export * from "./GuideCTA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__